import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { usePageContent } from "@/i18n/pageContent";

const CATS = [
  {
    slug: "formazione",
    eyebrow: "01 · Training",
    title: "Formazione",
    desc: "Corsi e percorsi formativi rivolti a istituzioni, università, imprese e cittadini, dedicati alla cultura europea.",
    img: "/formazione-hero.jpg",
  },
  {
    slug: "editoria",
    eyebrow: "02 · Publishing",
    title: "Editoria",
    desc: "Attività editoriali, magazine, contenuti digitali e pubblicazioni che raccontano l'Europa di oggi.",
    img: "/editoria-hero.jpg",
  },
  {
    slug: "networking",
    eyebrow: "03 · Networking",
    title: "Networking",
    desc: "Costruzione di reti internazionali tra istituzioni, ambasciate, università e operatori culturali nei 27 Stati membri.",
    img: "/networking-hero.jpg",
  },
  {
    slug: "eventi",
    eyebrow: "04 · Events",
    title: "Grandi Eventi Internazionali",
    desc: "Partecipazione e organizzazione di festival, mostre, contest fotografici, eventi sportivi e celebrazioni storiche.",
    img: "/eventi-hero.jpg",
  },
];

export default function Activities() {
  const c = usePageContent("activitiesIndex");
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
      />

      <section className="bg-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
            {CATS.map((c) => (
              <Link
                key={c.slug}
                to={`/activities/${c.slug}`}
                data-testid={`activity-card-${c.slug}`}
                className="group card-lift block reveal"
              >
                <div className="zoom-wrap aspect-[16/10] w-full bg-[#fafaf7]">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="pt-6">
                  <span className="eyebrow !text-[#1a365d]/70">{c.eyebrow}</span>
                  <h3 className="font-display text-2xl md:text-3xl text-[#1a365d] mt-3 group-hover:text-[#d4af37] transition-colors">
                    {c.title}
                  </h3>
                  <p className="font-body text-[#475569] text-[15px] leading-relaxed mt-4 max-w-md">
                    {c.desc}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[#1a365d] group-hover:text-[#d4af37] transition-colors text-[11px] tracking-[0.28em] uppercase font-medium">
                    Scopri <ArrowUpRight size={14} strokeWidth={1.8} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
